class CookieService {
  getCookie(name: string): string | undefined {
    const value = "; " + document.cookie;
    const parts = value.split("; " + name + "=");
    if (parts.length == 2) return parts.pop().split(";").shift();
  }

  addCookie(name: string, value: unknown, expiresTimeInMs: number): void {
    const date = new Date();
    date.setTime(date.getTime() + expiresTimeInMs);
    const expires = "expires=" + date.toUTCString();
    document.cookie = `${name}=${value}; ${expires} + "; path=/; `;
  }
}

export default new CookieService();
